import React from "react";
import { Box, Chip, IconButton, Stack, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { sanitizeHtml, parseContentToMap } from "../../Dialogs/DialogContributorCommentEditor";

const plugin = {
  table: "recent_comments",
  select: "id,user_id,username,content,created_at,updated_at",
  defaultSort: { field: "created_at", sort: "desc" },
  or(search) {
    if (!search) return undefined;
    const like = `%${search}%`;
    return `or=(username.ilike.${like},content.ilike.${like})`;
  },
  normalize(row) {
    const map = parseContentToMap(row.content);
    const languages = Object.keys(map || {});
    const displayContent =
      map?.ja ||
      map?.en ||
      map?.[languages[0]] ||
      "";
    return {
      ...row,
      _languages: languages,
      _contentHtml: sanitizeHtml(displayContent),
    };
  },
  columns({ onEdit }) {
    return [
      { field: "username", headerName: "User", minWidth: 160, flex: 1 },
      {
        field: "_languages",
        headerName: "Lang",
        width: 140,
        renderCell: (p) => (
          <Stack direction="row" spacing={0.5} flexWrap="wrap">
            {(p.row._languages || []).map((code) => (
              <Chip key={code} label={code.toUpperCase()} size="small" variant="outlined" />
            ))}
          </Stack>
        ),
      },
      {
        field: "_contentHtml",
        headerName: "Content",
        flex: 2,
        minWidth: 260,
        renderCell: (p) => (
          <Box
            sx={{ whiteSpace: "normal", lineHeight: 1.3, maxHeight: 72, overflow: "hidden" }}
            dangerouslySetInnerHTML={{ __html: p.row._contentHtml || "" }}
          />
        ),
      },
      {
        field: "created_at",
        headerName: "Created",
        width: 160,
        valueFormatter: (params) => {
          const v = params?.value;
          return v ? new Date(v).toLocaleString() : "—";
        },
      },
      {
        field: "updated_at",
        headerName: "Updated",
        width: 160,
        valueFormatter: (params) => {
          const v = params?.value;
          return v ? new Date(v).toLocaleString() : "—";
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        width: 90,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => onEdit?.(params.row)}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ),
      },
    ];
  },
};

export default plugin;
